"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8907 8.5235A5.966 5.966 0 0 1 17.917 11H20v2h-2.083a5.9674 5.9674 0 0 1-1.0263 2.4766l1.4731 1.4732-1.4142 1.4142-1.4731-1.4732A5.9679 5.9679 0 0 1 13 17.917V20h-2v-2.083a5.966 5.966 0 0 1-2.4765-1.0263l-1.4731 1.4731-1.4142-1.4142 1.473-1.4731A5.9675 5.9675 0 0 1 6.083 13H4v-2h2.083a5.9679 5.9679 0 0 1 1.0263-2.4766L5.6362 7.0502 7.0504 5.636l1.4731 1.4732A5.968 5.968 0 0 1 11 6.083V4h2v2.083a5.9675 5.9675 0 0 1 2.4765 1.0263l1.4731-1.4731 1.4142 1.4142-1.4731 1.473zM12 16c2.2091 0 4-1.7909 4-4 0-2.2091-1.7909-4-4-4-2.2091 0-4 1.7909-4 4 0 2.2091 1.7909 4 4 4z"
  })];
};

exports.default = _default;